import { FeederMethods } from './feeder';
import { LockMethods } from './lock';
import { StakingManagerMethods } from './manager';
import { RewardVaultMethods } from "./rewardVault";

export const StakingMethods = {
  ...FeederMethods,
  ...LockMethods,
  ...StakingManagerMethods,
  ...RewardVaultMethods,
};

export default StakingMethods;